/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateTicketDto } from '../models/CreateTicketDto';
import type { SearchTicketsRequestDto } from '../models/SearchTicketsRequestDto';
import type { SearchTicketsResponseDto } from '../models/SearchTicketsResponseDto';
import type { SeverityOptionsDto } from '../models/SeverityOptionsDto';
import type { StartTicketResponseDto } from '../models/StartTicketResponseDto';
import type { TicketDto } from '../models/TicketDto';
import type { TicketSystemsMetadataDto } from '../models/TicketSystemsMetadataDto';
import type { UpdateTicketDto } from '../models/UpdateTicketDto';
import type { UpdateTicketInternalDto } from '../models/UpdateTicketInternalDto';
import type { WorkflowContentDto } from '../models/WorkflowContentDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class TicketsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * The severity options per ticket type, for the frontend dropdowns.
     * @returns SeverityOptionsDto OK
     * @throws ApiError
     */
    public getApiSupportTicketsSeverityOptions(): CancelablePromise<Array<SeverityOptionsDto>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/support/Tickets/severity-options',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Which system this server is, and which sibling environments the caller may search.
     * Drives the System filter — the frontend has no hardcoded system list. Remote systems are
     * disclosed to HAVN Support only; everyone else gets an empty list, which the frontend
     * reads as "no system filter to show".
     * @returns TicketSystemsMetadataDto OK
     * @throws ApiError
     */
    public getApiSupportTicketsSystems(): CancelablePromise<TicketSystemsMetadataDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/support/Tickets/systems',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns TicketDto Created
     * @throws ApiError
     */
    public postApiSupportTickets(
        requestBody?: CreateTicketDto,
    ): CancelablePromise<TicketDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/support/Tickets',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Starts a new ticket: creates the backing "Support Ticket" workflow and a draft ticket row
     * for its form to populate, then returns both so the caller can open the workflow form
     * straight away.
     *
     * This is the "New Issue" entry point. The row must exist before the form opens because
     * SaveToTable writes onto an existing ticket — the form fills in Subject, Type, Severity,
     * Description and so on. The ticket therefore starts as an empty `Draft`; deleting the
     * workflow cascade-deletes it, so an abandoned form leaves nothing behind.
     * @returns StartTicketResponseDto Created
     * @throws ApiError
     */
    public postApiSupportTicketsStart(): CancelablePromise<StartTicketResponseDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/support/Tickets/start',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param ticketGuid
     * @returns TicketDto OK
     * @throws ApiError
     */
    public getTicket(
        ticketGuid: string,
    ): CancelablePromise<TicketDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/support/Tickets/{ticketGuid}',
            path: {
                'ticketGuid': ticketGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param ticketGuid
     * @param requestBody
     * @returns TicketDto OK
     * @throws ApiError
     */
    public putApiSupportTickets(
        ticketGuid: string,
        requestBody?: UpdateTicketDto,
    ): CancelablePromise<TicketDto> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/support/Tickets/{ticketGuid}',
            path: {
                'ticketGuid': ticketGuid,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * The workflow content of a ticket that lives on ANOTHER system, for the read-only remote
     * view — the cross-system search returns rows whose workflows do not exist locally, and
     * this is how the viewer opens one. Scoped to support tickets: the workflow is resolved
     * from the remote ticket row, so this cannot fetch arbitrary remote workflows.
     *
     * Read-only by construction: the remote context blocks SaveChanges outright, and the
     * write/enrich steps of the local GetWorkflow (auto-creating missing form responses,
     * SaveToTable enrichment, shared answers) are skipped — a form with no response simply
     * does not render, and answers show their raw stored values.
     * @param systemKey
     * @param ticketGuid
     * @returns WorkflowContentDto OK
     * @throws ApiError
     */
    public getApiSupportTicketsRemoteWorkflow(
        systemKey: string,
        ticketGuid: string,
    ): CancelablePromise<WorkflowContentDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/support/Tickets/remote-workflow/{systemKey}/{ticketGuid}',
            path: {
                'systemKey': systemKey,
                'ticketGuid': ticketGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns SearchTicketsResponseDto OK
     * @throws ApiError
     */
    public postApiSupportTicketsSearch(
        requestBody?: SearchTicketsRequestDto,
    ): CancelablePromise<SearchTicketsResponseDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/support/Tickets/search',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Update a ticket's internal (support-only) fields: development status, internal assignee,
     * GitHub number, assignment group.
     *
     * Open to either support role as well as SuperAdmin. The attribute only gates <em>who may
     * call it</em>; M:Compliance.Module.Support.Controllers.TicketsController.CanAccessAsync(Compliance.Module.Support.DbModels.SupportTicket) below still decides which tickets they may touch, so
     * Client Support remains confined to its own organization.
     * @param ticketGuid
     * @param requestBody
     * @returns TicketDto OK
     * @throws ApiError
     */
    public putApiSupportTicketsInternal(
        ticketGuid: string,
        requestBody?: UpdateTicketInternalDto,
    ): CancelablePromise<TicketDto> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/support/Tickets/{ticketGuid}/internal',
            path: {
                'ticketGuid': ticketGuid,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
}
